var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStructre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.857 11H26.7969C28.0133 11 29 11.9953 29 13.2232V16.1877C29 17.4146 28.0133 18.4109 26.7969 18.4109H23.857C22.6397 18.4109 21.653 17.4146 21.653 16.1877V13.2232C21.653 11.9953 22.6397 11 23.857 11Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.204 11H16.143C17.3603 11 18.3471 11.9953 18.3471 13.2232V16.1877C18.3471 17.4146 17.3603 18.4109 16.143 18.4109H13.204C11.9867 18.4109 11 17.4146 11 16.1877V13.2232C11 11.9953 11.9867 11 13.204 11Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.204 21.5891H16.143C17.3603 21.5891 18.3471 22.5844 18.3471 23.8132V26.7768C18.3471 28.0047 17.3603 29 16.143 29H13.204C11.9867 29 11 28.0047 11 26.7768V23.8132C11 22.5844 11.9867 21.5891 13.204 21.5891Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.857 21.5891H26.7969C28.0133 21.5891 29 22.5844 29 23.8132V26.7768C29 28.0047 28.0133 29 26.7969 29H23.857C22.6397 29 21.653 28.0047 21.653 26.7768V23.8132C21.653 22.5844 22.6397 21.5891 23.857 21.5891Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructre);
export default __webpack_public_path__ + "static/media/structre.f8eec0e8c4d025ef1f20c78df9b22f30.svg";
export { ForwardRef as ReactComponent };